import { Auth, graphqlOperation } from 'aws-amplify';

export async function getJwtToken(): Promise<string> {
  const session = await Auth.currentSession();
  const idToken = session.getIdToken();
  return idToken.getJwtToken();
}
